export default __webpack_public_path__ + "static/media/bar.96c97740.svg";